import styled from 'styled-components';
import { Countdown } from '@landlord-tech/ui-kit-opp/dist/components/Countdown';

const SCountdown = styled(Countdown)`
  && {
  }
`;

export default SCountdown;
